import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IHallsState, IHalls} from "./types";
import {fetchHalls} from "./asyncActions";

const initialState: IHallsState = {
    halls: [],
    isLoading: false
}

const GetHalls = createSlice({
  name: "getSubscriptions",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
      builder.addCase(fetchHalls.pending, (state) => {
          state.isLoading = true;
      })
      builder.addCase(
          fetchHalls.fulfilled,
          (state, action: PayloadAction<IHalls[]>) => {
              state.halls = action.payload
              state.isLoading = false;
          }
      );
  },
});

export default GetHalls.reducer;

